import React from 'react';
import { Link } from 'react-router-dom';
import { Avatar, Space, Typography } from 'antd';
import { UserOutlined } from '@ant-design/icons';

import { useClient } from '../../models/useClient';

const { Text } = Typography;

/**
 * The canonical client preview: avatar + displayName linking to the
 * client's profile. Resolves the client live from its id (subscribe-first
 * house hook); shows the raw id only while loading or when the doc is
 * missing. Default link target is the ADMIN profile — pass `to` for
 * other surfaces.
 */
const ClientPreview = ({ clientId, to }) => {
  // House hook convention: [loading, data, error] tuples — the object
  // destructure here once made `client` permanently undefined (caught by
  // Charles: "no name, no avatar", with tests that mocked the wrong shape).
  const [, client] = useClient(clientId) || [];
  if (!clientId) return null;
  const href = to || `/admin/clients/${clientId}`;
  return (
    <Link to={href}>
      <Space size={8} align="center">
        {/* ALWAYS this client's own image — never the team's, and never
            FallbackAvatar (which renders the VIEWER's initial: right for
            own-profile contexts, wrong when previewing someone else). */}
        <Avatar src={client && client.avatar} icon={<UserOutlined />} />
        <Text>{(client && client.displayName) || clientId}</Text>
      </Space>
    </Link>
  );
};

export default ClientPreview;
